import { darkTheme } from '@devrangex/rui'
import { Theme } from '@emotion/react'


declare module '@emotion/react' {
  export interface Theme {
    bay: {
      background: string
      private: string
    }
  }
}

export const dark: Theme = {
  ...darkTheme,
  bay: {
    background: '#131517',
    private: '#FE0',
  },
}
